import { CONTENTDB_S3_URL, WEBDB_S3_URL } from '../envs.js';
import { isContentDbEnabled } from '../urlHandling/urlSearchParams.js';
export const fileExtension = [
    'pdf',
    'doc',
    'xlsx',
    'ppt',
    'zip',
    'png',
    'jpg',
    'eps',
];
const fileExtensionRegex = new RegExp(`.(${fileExtension.join('|')})$`, 'i');
export function removeExtension(fileName) {
    return fileName.replace(fileExtensionRegex, '');
}
export async function fetchStaticPageOrTopic(key, lang, b2b = false) {
    const b2bDbUrl = isContentDbEnabled ? CONTENTDB_S3_URL : WEBDB_S3_URL;
    const propagatedParams = typeof document !== 'undefined' ? document.location.search : '';
    const mergedUrl = b2b
        ? `${b2bDbUrl}/b2b_merged/${lang}/${key}.json${propagatedParams}`
        : `${WEBDB_S3_URL}/merged/${lang}/${key}.json${propagatedParams}`;
    return fetch(mergedUrl).then((r) => (r.ok ? r.json() : null));
}
export function isTopic(spt) {
    return spt.kind === 'topic';
}
export function isStaticPage(spt) {
    return spt.kind === 'static_page';
}
export function findTopicTabFromHash(spt, hash, lang) {
    const staticPageKey = decodeURI(hash?.replace('#', '').replace(' ', ''));
    if (staticPageKey && staticPageKey.length) {
        const index = spt.staticPages.findIndex((sp) => {
            const titles = Object.values(sp.titleShort).map((t) => {
                return t.replace(' ', '');
            });
            return titles.includes(staticPageKey);
        });
        if (index > -1) {
            const newHash = `#${spt.staticPages[index].titleShort[lang].replace(' ', '')}`;
            return {
                selectedTab: index,
                hash: newHash,
            };
        }
    }
    return null;
}
//# sourceMappingURL=api-static-pages-and-topics.js.map